<template>
  <div>
    <!-- 顶部联系栏 -->
    <div class="top">
      <div class="container">
        <div class="row">
          <div class="tp_zc">
            <ul class="row">
              <li><i class="iconfont icon-youxiang1"></i><a
                  href="mailto:info@cnhonorgroup.com">info@cnhonorgroup.com</a></li>
              <li><i class="iconfont icon-dianhua4"></i>+86 4009-710-788</li>
            </ul>
          </div>
          <div class="tp_yc">
            <ul class="row">
              <li><a
                  href="https://www.facebook.com/people/%E5%B1%B1%E4%B8%9C%E5%8D%8E%E8%AA%89%E6%9C%BA%E6%A2%B0%E8%AE%BE%E5%A4%87%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/61587418161345/"
                  target="_blank"><i class="iconfont icon-facebook-fill"></i></a></li>
              <!-- <li><a href=""><i class="iconfont icon-youtube"></i></a></li>
              <li><a href=""><i class="iconfont icon-douyin"></i></a></li>
              <li><a href=""><i class="iconfont icon-linkedin-fill1"></i></a></li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 导航栏 -->
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="logo"><a href="/"><img src="/images/logo.svg"></a></div>
          <div class="nav">
            <ul class="jt_ct an_tm">
              <li :class="{ 'on': nowIndex == 0 }">
                <div class="y_j"><a href="/">Home</a></div>
              </li>
              <li :class="{ 'on': nowIndex == 1 }">
                <div class="y_j"><a href="/about">About Us</a><i class="iconfont icon-zuojiantou"></i></div>
                <div class="e_j">
                  <div class="s_b"><i class="iconfont icon-youjiantou"></i></div>
                  <div class="f_l"><a href="/about#lm_a">Company Introduction</a></div>
                  <div class="f_l"><a href="/about#lm_b">Enterprise Chronicle</a></div>
                  <div class="f_l"><a href="/about#lm_c">Corporate Culture</a></div>
                  <div class="f_l"><a href="/about#lm_d">Public Welfare</a></div>
                  <div class="f_l"><a href="/about#lm_e">At The Exhibition</a></div>
                </div>
              </li>
              <li id="p_r" :class="{ 'on': nowIndex == 2 }">
                <div class="y_j"><a href="/products">Products</a><i class="iconfont icon-zuojiantou"></i></div>
                <div class="e_j">
                  <div class="s_b"><i class="iconfont icon-youjiantou"></i></div>
                  <div class="container">
                    <div class="cp_lm">
                      <div class="cp_xl" v-for="(item, index) in typeDataFive" :key="index">
                        <h3><a href="/products">{{ item.value }}</a></h3>
                        <p v-for="(item2, index2) in item.data" :key="index2"><a :href="`/products?type=${item2.id}`">{{
                          item2.value }}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="{ 'on': nowIndex == 3 }">
                <div class="y_j"><a href="/turnkey_projects">Turnkey Projects</a></div>
              </li>
              <li :class="{ 'on': nowIndex == 4 }">
                <div class="y_j"><a href="/services">Service & Support</a></div>
              </li>
              <li :class="{ 'on': nowIndex == 5 }">
                <div class="y_j"><a href="/news">News</a></div>
              </li>
              <li :class="{ 'on': nowIndex == 6 }">
                <div class="y_j"><a href="/contact">Contact Us</a></div>
              </li>
            </ul>
            <div class="s_ch" @click="showSearch = true"><i class="iconfont icon-sousuo"></i></div>
            <div class="yy_xz" @mouseenter="showLang = true" @mouseleave="showLang = false">
              <div class="y_x"><i class="iconfont icon-diqiu"></i></div>
              <div class="x_z" v-show="showLang">
                <a href="javascript:;" @click="switchLang('english')"><img src="/images/en.png" alt="">English</a>
                <a href="javascript:;" @click="switchLang('chinese_simplified')"><img src="/images/cn.png" alt="">简体中文</a>
                <a href="javascript:;" @click="switchLang('chinese_traditional')"><img src="/images/cn.png" alt="">繁體中文</a>
                <a href="javascript:;" @click="switchLang('russian')"><img src="/images/ru.png" alt="">Русский</a>
                <a href="javascript:;" @click="switchLang('spanish')"><img src="/images/es.png" alt="">Español</a>
                <a href="javascript:;" @click="switchLang('french')"><img src="/images/fr.png" alt="">Français</a>
                <a href="javascript:;" @click="switchLang('portuguese')"><img src="/images/br.png" alt="">Português</a>
                <a href="javascript:;" @click="switchLang('arabic')"><img src="/images/sa.png" alt="">العربية</a>
              </div>
            </div>
          </div>
          <div class="an" @click="showMenu = !showMenu"><span class="a1"></span><span class="a2"></span><span
              class="a3"></span></div>
        </div>
      </div>
    </div>

    <!-- 头部占位 -->
    <div class="head_h"></div>

    <!-- 搜索框 -->
    <div class="search" v-show="showSearch">
      <div class="sc_bj">
        <div class="sc_gb" @click="showSearch = false"><i class="iconfont icon-guanbi1"></i></div>
        <div class="sc_nr">
          <input v-model="searchKey" type="text" placeholder="Please enter keywords">
          <button @click="searchProduct"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Header',
  data() {
    return {
      showSearch: false, // 搜索框显示状态
      showLang: false,   // 语言下拉显示状态
      showMenu: false,    // 移动端菜单显示状态
      searchKey: '',      // 搜索关键词
    }
  },
  mounted() {
    // Vue 组件渲染完成后执行翻译
    this.$nextTick(() => {
      if (window.translate) {
        window.translate.execute();
      }
    });
  },
  methods: {
    // 切换语言
    switchLang(lang) {
      if (window.translate) {
        window.translate.changeLanguage(lang);
      }
      this.showLang = false;
    },
    // 搜索产品
    searchProduct() {
      console.log(this.searchKey)
      if (this.searchKey.trim() === '') {
        this.$message({
          message: 'Please enter keywords',
          type: 'warning'
        });
        return;
      }
      window.open(`/products?txt=${this.searchKey}`, '_self');
    }
  },
  computed: {
    ...mapState(['productTypes']),
    typeDataFive() {
      return this.productTypes.slice(0, 5);
    },
    nowIndex() {
      let index = 0;
      console.log('111111:', this.$route.path)
      console.log(this.$route.path.startsWith('/product_xq'))
      if (this.$route.path.startsWith('/about')) {
        index = 1;
      } else if (this.$route.path.startsWith('/product')) {
        // console.log(this.$route.path)
        index = 2;
      } else if (this.$route.path.startsWith('/turnkey_projects') || this.$route.path.startsWith('/case_details')) {
        index = 3;
      } else if (this.$route.path.startsWith('/services')) {
        index = 4;
      } else if (this.$route.path.startsWith('/news')) {
        index = 5;
      } else if (this.$route.path.startsWith('/contact')) {
        index = 6;
      } else {
        index = 0;
      }
      console.log(index)
      return index
    }
  }
}
</script>

<style></style>